import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { FormHelper } from "utils";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import ToolTip from "components/ToolTip/ToolTip";
import { SvgComponent } from "components";

export default function ComprobantesElectronicosTab({ compania, setCompania, setCheckedProp }) {
  function ToggleRow({ name, label, tooltip, checked, onChange }) {
    return (
      <div
        className="d-flex align-items-center justify-content-between py-2"
        style={{ marginBottom: "40px" }}
      >
        <div className="d-flex align-items-center">
          <span>{label}</span>
          <ToolTip message={tooltip} placement="top">
            <span
              className="ml-2"
              style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}
            >
              <SvgComponent iconName="info" fill="#1E88E5" />
            </span>
          </ToolTip>
        </div>
        <Form.Check
          type="switch"
          id={`sw-${name}`}
          name={name}
          checked={!!checked}
          onChange={onChange}
          label=""
        />
      </div>
    );
  }

  return (
    <div className="px-3 pb-4">
      <EditSection title="Modo de Contingencia" style={{}}>
        <SectionRow>
          <Row className="mx-0 mt-3">
            <Col xs={12} md={10} lg={9} className="px-0">
              <ToggleRow
                key="ModoContingenciaLigera"
                name="ModoContingenciaLigera"
                label="Ligera"
                tooltip="Modo de contigencia que inhabilita temporalmente el envío de comprobantes a la DGII. Los comprobantes emitidos en este modo se quedarán 'Pendientes de envío' y deberán ser enviados en un plazo no mayor a 72 horas."
                checked={compania.ModoContingenciaLigera}
                onChange={setCheckedProp}
              />
            </Col>
          </Row>
        </SectionRow>
      </EditSection>

      {compania.ManejarSecuenciasFiscalesAutomaticamente && (
        <EditSection title="Alerta de punto de reorden de e-NCF por Tipo de Comprobante" style={{}}>
          <SectionRow>
            <Row className="mx-0 mt-3">
              <Col xs={12} md={10} lg={9} className="px-0">
                <ToggleRow
                  key="UsaAlertarFinSerie"
                  name="UsaAlertarFinSerie"
                  label="Alertar Fin de Series"
                  tooltip="Envía una alerta a los correos indicando que las series fiscales se han agotado."
                  checked={compania.UsaAlertarFinSerie}
                  onChange={setCheckedProp}
                />
              </Col>
            </Row>
          </SectionRow>

          {compania.UsaAlertarFinSerie && (
            <>
              <SectionRow>
                <InputContainer stacked label="Correos receptores de las Alerta">
                  <Form.Control
                    name="EmailsAlertar"
                    type="text"
                    placeholder="Ingresa emails separado por (,)"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.EmailsAlertar}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow columns={6}>
                <InputContainer stacked label="Cantidad mínima E31">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie}
                  />
                </InputContainer>

                <InputContainer stacked label="Cantidad mínima E32">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie2"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie2}
                  />
                </InputContainer>

                <InputContainer stacked label="Cantidad mínima E33">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie3"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie3}
                  />
                </InputContainer>

                <InputContainer stacked label="Cantidad mínima E34">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie4"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie4}
                  />
                </InputContainer>

                <InputContainer stacked label="Cantidad mínima E41">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie8"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie8}
                  />
                </InputContainer>

                <InputContainer stacked label="Cantidad mínima E43">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie9"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie9}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow columns={6}>
                <InputContainer stacked label="Cantidad mínima E44">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie10"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie10}
                  />
                </InputContainer>

                <InputContainer stacked label="Cantidad mínima E45">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie5"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie5}
                  />
                </InputContainer>

                <InputContainer stacked label="Cantidad mínima E46">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie6"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie6}
                  />
                </InputContainer>

                <InputContainer stacked label="Cantidad mínima E47">
                  <Form.Control
                    name="CantidadMinimaAlertaSerie7"
                    type="number"
                    placeholder="Cantidad mínima"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.CantidadMinimaAlertaSerie7}
                  />
                </InputContainer>
              </SectionRow>
            </>
          )}
        </EditSection>
      )}
    </div>
  );
}
